export default __webpack_public_path__ + "static/desktop_14-e4e4b31adf09f4af68781359bb687b46.webp";